import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

import { watch, onMounted } from "vue";
import { useLocalStorage } from "@vueuse/core";

import { useAsync } from "@/use/useAsync";
import { useNews } from "@/use/useNews";
import { useStore } from "@/use/useStore";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";

import UiCollapse from "@/components/ui/UiCollapse.vue";
import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";

import NewsPost from "@/features/news/components/NewsPost.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LastNews',
  setup(__props) {

const { currentUser } = useStore();
const { news, fetchNews } = useNews();

const fetchData = useAsync(() => fetchNews({ limit: "1" }), true);

const expanded = useLocalStorage("expand-last-news", true);

watch(() => currentUser.value?.id, fetchData.execute);

return (_ctx: any,_cache: any) => {
  return (Array.isArray(_unref(news)) && _unref(news).length > 0)
    ? (_openBlock(), _createBlock(UiGroup, _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), {
        default: _withCtx(() => [
          _createVNode(UiCollapse, {
            modelValue: _unref(expanded),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(expanded) ? (expanded).value = $event : null))
          }, {
            header: _withCtx(() => [
              _createVNode(UiHeader, { title: "Последнее объявление" }, {
                right: _withCtx(() => [
                  _createVNode(UiIcon, {
                    size: 18,
                    class: _normalizeClass([{ 'transform-gpu rotate-180': _unref(expanded) }, "transition duration-200"]),
                    icon: "ChevronDown"
                  }, null, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(UiCard, null, {
                default: _withCtx(() => [
                  _createVNode(UiSuspense, {
                    failure: _unref(fetchData).isFailure.value,
                    pending: _unref(fetchData).isPending.value,
                    success: _unref(fetchData).isSuccess.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(news), (post) => {
                        return (_openBlock(), _createBlock(NewsPost, {
                          key: post.id,
                          post: post
                        }, null, 8, ["post"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["failure", "pending", "success"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 16))
    : _createCommentVNode("", true)
}
}

})